import { useMutation } from '@tanstack/react-query';
import { createDepositOperation } from '@/shared/api';
import type {
  CreateDepositOperationParams,
  DepositCreateOperationType,
} from '@/shared/types';

interface UseCardDepositOptions<TResponse> {
  operationType: DepositCreateOperationType;
  onSuccess?: (data: TResponse) => void;
  onError?: (error: Error) => void;
}

export function useCreateDepositOperation<TResponse>({
  operationType,
  onSuccess,
  onError,
}: UseCardDepositOptions<TResponse>) {
  const mutation = useMutation<TResponse, Error, CreateDepositOperationParams>({
    mutationFn: data => createDepositOperation(operationType, data),
    onSuccess,
    onError,
  });

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    data: mutation.data,
    isCreateOperationDepositLoading: mutation.isPending,
    isCreateOperationDepositError: mutation.isError,
    createOperationDepositError: mutation.error,
    isSuccess: mutation.isSuccess,
    reset: mutation.reset,
    isPending: mutation.isPending,
  };
}
